import React from 'react'
import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'

const LightOrangeTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#FEEBDD',
    color: '#F67443',
    boxShadow: '0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)',
    paddingRight: 24,
    paddingLeft: 24,
    paddingTop: 16,
    paddingBottom: 16,
    fontSize: 14,
    fontWeight: 400,
    borderRadius: 10,
    minWidth: 400,
  },
}))

export default LightOrangeTooltip
